<template>
            <div :class="{'content': true, 'open': sidebarOn}">
                <div class="shadow" @click="toggleSidebar"></div>
                <div class="header-nav fixed-position full-width">
                    <div :style="`margin-left: ${sidebarOn ? '230px' : '82px'}; transition: margin-left 0.2s ease;`"
                        class="header-inner flex align-items-center justify-content-space-between margin-horizontal-small">
                        <div class="flex align-items-center">
                            <router-link to="/"><img src="./assets/logo.png" class="logo" /></router-link>
                        </div>
                        <div class="header-search" v-click-outside="hideSearchResults">
                            <div class="search-box">
                                <vue-feather type="search" class="" size="18"/>
                                <input
                                    v-model="keyword"
                                    :placeholder="currentLanguage === 'TA' ? 'இங்கே தேடுங்கள்...' : 'Search begins here...'"
                                    class="search-field"
                                    @focus="showSearchResults = true"
                                />
                                <div v-if="searching" class="search-loading">
                                    <vue-feather type="loader" animation="spin" size="16"></vue-feather>
                                </div>
                                <!-- <button 
                                    v-if="keyword && !searching" 
                                    @click="clearSearch" 
                                    class="search-clear-button"
                                    type="button"
                                    title="Clear search"
                                >
                                    <vue-feather type="x" size="16" stroke-width="2"></vue-feather>
                                </button> -->
                            </div>
                            

                            <div class="search-results" v-if="showSearchResults && ((searchResults != null && searchResults.length > 0) || (userResults != null && userResults.length > 0))">
                                <template v-if="searchResults != null && searchResults.length > 0">
                                    <div class="search-results-header">
                                        <span>{{ currentLanguage === 'TA' ? 'வீடியோக்கள்' : 'Videos' }}</span>
                                    </div>
                                    <div v-for="result in searchResults" :key="result.id" class="search-item" @click="hideSearchResults">
                                        <router-link :to="`/watch/${result.id}`">
                                            <div class="search-item-content">
                                                <div class="search-item-thumbnail">
                                                    <img :src="getSearchThumbnail(result)" :alt="currentLanguage === 'EN' ? (result.titleEN || result.titleTA) : (result.titleTA || result.titleEN)" @error="handleThumbnailError" />
                                                </div>
                                                <div class="search-item-details">
                                                    <div class="search-item-title">
                                                        {{ currentLanguage === 'EN' ? (result.titleEN || result.titleTA) : (result.titleTA || result.titleEN) }}
                                                        <span v-if="isDraftSearchResult(result)" class="search-item-badge" :class="draftBadgeClass(result)">{{ draftBadgeLabel(result) }}</span>
                                                    </div>
                                                    <div class="search-item-meta">
                                                        <span class="search-item-channel" v-if="result.owner">{{ result.owner.displayName || result.owner.username || 'Unknown' }}</span>
                                                        <span class="search-item-separator" v-if="result.owner">•</span>
                                                        <span class="search-item-views">{{ formatNumber(result.viewsCount || 0) }} {{ currentLanguage === 'TA' ? 'பார்வைகள்' : 'views' }}</span>
                                                        <span class="search-item-separator" v-if="formatTimeAgo(result.createdAt)">•</span>
                                                        <span class="search-item-date" v-if="formatTimeAgo(result.createdAt)">{{ formatTimeAgo(result.createdAt) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </router-link>
                                    </div>
                                </template>

                                <template v-if="userResults != null && userResults.length > 0">
                                    <div class="search-results-header">
                                        <span>{{ currentLanguage === 'TA' ? 'சேனல்கள்' : 'Channels' }}</span>
                                    </div>
                                    <div v-for="user in userResults" :key="'user-' + user.id" class="search-item" @click="hideSearchResults">
                                        <router-link :to="`/@${user.username}`">
                                            <div class="search-item-content">
                                                <div class="search-item-avatar">
                                                    <img :src="getUserAvatar(user)" :alt="getSearchUserName(user)" @error="handleAvatarError" />
                                                </div>
                                                <div class="search-item-details">
                                                    <div class="search-item-title">
                                                        {{ getSearchUserName(user) }}
                                                        <vue-feather v-if="user.status === 'verified'" type="check-circle" class="verified-badge-inline" size="12" stroke-width="2"></vue-feather>
                                                    </div>
                                                    <div class="search-item-meta">
                                                        <span class="search-item-channel" v-if="user.username">@{{ user.username }}</span>
                                                        <span class="search-item-separator" v-if="user.username">•</span>
                                                        <span class="search-item-views">{{ formatNumber(user.subscribersCount || 0) }} {{ currentLanguage === 'TA' ? 'சந்தாதாரர்கள்' : 'subscribers' }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </router-link>
                                    </div>
                                </template>
                            </div>

                            <div class="search-results" v-if="showSearchResults && keyword && searchResults != null && searchResults.length === 0 && (userResults == null || userResults.length === 0)">
                                <div class="search-no-results">
                                    <vue-feather type="search" size="24" stroke-width="2"></vue-feather>
                                    <p>No results found for "{{ keyword }}"</p>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Language Switch -->
                        <div class="language-switch">
                            <button 
                                @click="toggleLanguage" 
                                class="language-toggle"
                                :class="{ 'active': currentLanguage === 'TA' }"
                                title="Switch between English and Tamil"
                            >
                                <span class="language-text">{{ currentLanguage }}</span>
                                <vue-feather type="globe" size="16" stroke-width="2"></vue-feather>
                            </button>
                        </div>
                        
                        <div class="right-header flex align-items-center">
                            <button @click="toggleDarkMode" class="dark-mode-btn" :title="darkMode ? 'Light mode' : 'Night mode'">
                                <vue-feather :type="darkMode ? 'sun' : 'moon'" size="18" />
                            </button>
                            <template v-if="isLoggedIn">
                            <div class="upload-header flex margin-horizontal-small">
                                <div class="upload-field">
                                    <div class="upload-button" v-if="!(uploading || uploaded)">
                                        <input type="file" @change="onFileChange" accept="video/mp4" hidden
                                            id="upload-file" />
                                        <label for="upload-file" class="btn btn_primary">
                                            <vue-feather type="upload" class="icon-upload margin-horizontal-tiny"
                                                size="20" />
                                            {{ currentLanguage === 'TA' ? 'பதிவேற்ற' : 'Upload' }}
                                        </label>
                                    </div>
                                    <div class="upload-status" v-if="uploading">
                                        <div class="progress-container">
                                            <div class="progress-bar">
                                                <div class="progress-fill" :style="{ width: uploadProgress + '%' }"></div>
                                            </div>
                                            <div class="progress-text">{{ currentLanguage === 'TA' ? 'பதிவேற்றப்படுகிறது ' : 'Uploading' }} {{ parseInt(uploadProgress) }}%</div>
                                        </div>
                                    </div>
                                    <div class="upload-preparing" v-if="uploaded && preparing">
                                        <div class="preparing-container">
                                            <vue-feather type="loader" animation="spin" size="16"></vue-feather>
                                            <span class="preparing-text">{{ currentLanguage === 'TA' ? 'தயாராகிறது...' : 'Preparing...' }}</span>
                                        </div>
                                    </div>
                                    <div class="upload-preview" v-if="hasPendingUploadReminder && uploaded && !preparing">
                                        <router-link :to="`/finish/${newVideo.id}`" class="btn btn_primary">{{ currentLanguage === 'TA' ? 'பதிவேற்றத்தை முடிக்க' : 'Finish upload' }}</router-link>
                                    </div>
                                </div>
                                <router-link to="/messages" class="notification-button">
                                    <vue-feather type="message-square" size="18"/>
                                    <span v-if="unreadMessageCount > 0" class="unread-badge">{{ unreadMessageCount > 9 ? '9+' : unreadMessageCount }}</span>
                                </router-link>
                                <div class="notification-button" @click="toggleNotifications" v-click-outside="hideNotifications">
                                    <vue-feather type="bell" size="18"/>
                                    <span v-if="unreadCount > 0" class="unread-badge">{{ unreadCount > 9 ? '9+' : unreadCount }}</span>
                                </div>
                            </div>
                            <div class="header-profile-image" @click="toggleMenu" v-click-outside="hideMenu">
                                <img class="profile-image" :src="avatarURL" :alt="accountDisplayName" @error="handleAvatarError" />
                            </div>
                            <div :class="{'profile-dropdown': true, 'open': menuOn}" v-if="isLoggedIn">
                                <ul>
                                    <li class="flex justify-content-space-between padding-horizontal-small">
                                        <div class="action-icon-button logout">
                                            <vue-feather type="log-out" class="icon-logout" size="20" @click="handleSignOut"/>
                                        </div>
                                        <div class="profile-info">
                                            <router-link :to="profileRoute">
                                                <img class="profile-image" :src="avatarURL" :alt="accountDisplayName" @error="handleAvatarError" />
                                                <div class="profile-label">
                                                    <div>{{accountDisplayName}}</div>
                                                    <div>{{profileUsername}}</div>
                                                </div>
                                            </router-link>
                                        </div>
                                        <div class="settings">
                                            <router-link to="/settings" class="action-icon-button">
                                                <vue-feather type="settings" class="icon-settings" size="20" />
                                            </router-link>
                                        </div>
                                    </li>
                                    <li class="divider"></li>
                                    <li>
                                        <router-link to="/studio" class="flex header-menu-item">
                                            <vue-feather type="video" class="icon-profile" size="20" />
                                            {{ currentLanguage === 'TA' ? 'வீடியோ அரங்கம்' : 'Video studio' }}
                                        </router-link>
                                    </li>
                                    <li class="divider"></li>
                                    <li>
                                        <router-link to="/subscriptions" class="flex header-menu-item">
                                            <vue-feather type="layers" class="icon-profile" size="20" />
                                            {{ currentLanguage === 'TA' ? 'சந்தாக்கள்' : 'Subscriptions' }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/articles" class="flex header-menu-item">
                                            <vue-feather type="file-text" class="icon-profile" size="20" />
                                            {{ currentLanguage === 'TA' ? 'எனது கட்டுரைகள்' : 'My articles' }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/playlists" class="flex header-menu-item">
                                            <vue-feather type="list" class="icon-profile" size="20" />
                                            {{ currentLanguage === 'TA' ? 'பட்டியல்கள்' : 'Playlists' }}
                                        </router-link>
                                    </li>
                                    <li v-if="isAdmin">
                                        <router-link to="/admin" class="flex header-menu-item">
                                            <vue-feather type="aperture" class="icon-profile" size="20" />
                                            {{ currentLanguage === 'TA' ? 'நிர்வாகப் பலகம்' : 'Admin panel' }}
                                        </router-link>
                                    </li>
                                </ul>
                            </div>

                            <div :class="{'notifications': true, 'open': notificationsOn}" v-if="isLoggedIn">
                                <h2>{{ currentLanguage === 'TA' ? 'அறிவிப்புகள்' : 'Notifications' }}<span class="notific-count" v-if="activeNotificationUnreadCount > 0">{{ activeNotificationUnreadCount }}</span></h2>
                                <div class="notification-list" @scroll="onNotificationScroll">
                                <div v-if="loadingNotifications" class="loading-notifications">
                                    <vue-feather type="loader" animation="spin" size="24"></vue-feather>
                                    <span>{{ currentLanguage === 'TA' ? 'அறிவிப்புகளை ஏற்றுகிறது...' : 'Loading notifications...' }}</span>
                                </div>
                                <div v-else-if="notifications.length === 0" class="no-notifications">
                                    <vue-feather type="bell" size="24" />
                                    <p>{{ currentLanguage === 'TA' ? 'இன்னும் அறிவிப்புகள் இல்லை' : 'No notifications yet' }}</p>
                                </div>
                                <router-link
                                    v-else
                                    v-for="notification in notifications"
                                    :key="notification.id"
                                    :to="getNotificationLink(notification)"
                                    :class="['notification-item', 'no-decoration', { 'unread': isUnread(notification) }]"
                                >
                                    <div class="profile-image">
                                        <img :src="getUserAvatar(notification.profile)" @error="handleAvatarError" />
                                        <vue-feather
                                            :type="getNotificationIcon(notification.type)"
                                            class="icon-video"
                                            size="12"
                                        />
                                    </div>
                                    <div class="notification-content text-start">
                                        <div class="notification-header-row">
                                            <div class="notification-title">
                                                <b>{{ getNotificationActor(notification) }}</b>
                                                <span>{{ getNotificationAction(notification) }}</span>
                                            </div>
                                            <span v-if="isUnread(notification)" class="unread-dot"></span>
                                        </div>
                                        <div v-if="getNotificationPreview(notification)" class="notification-preview">
                                            {{ getNotificationPreview(notification) }}
                                        </div>
                                        <div v-if="notification.video" class="notification-target">
                                            <img :src="getSearchThumbnail(notification.video)" @error="handleThumbnailError" />
                                            <span class="notification-target-title">{{ getNotificationTargetTitle(notification) }}</span>
                                        </div>
                                        <div class="notification-meta">
                                            <vue-feather type="clock" size="12" stroke-width="2"></vue-feather>
                                            <span>{{ formatTimeAgo(notification.createdAt) }}</span>
                                        </div>
                                    </div>
                                </router-link>
                                <div v-if="loadingMoreNotifications" class="loading-more-notifications">
                                    <vue-feather type="loader" animation="spin" size="16"></vue-feather>
                                </div>
                                </div>
                            </div>
                            </template>

                            <button v-if="!isLoggedIn" class="btn btn_primary login-button" @click="openLogin()">
                                <vue-feather type="log-in" size="18" class="margin-horizontal-tiny" />
                                {{ currentLanguage === 'TA' ? 'உள்நுழைக' : 'Login' }}
                            </button>

                        </div>
                    </div>
                </div>

                <div :class="{'side-bar': true, 'expanded': sidebarOn}">
                    <div class="sidebar-header">
                        <div :class="{ 'hamburger-container': true, 'change': this.sidebarOn }"
                            @click="toggleSidebar">
                            <div class="bar1"></div>
                            <div class="bar2"></div>
                            <div class="bar3"></div>
                        </div>
                    </div>

                    <div class="sidebar-nav-section">
                        <router-link
                            v-for="route in sidebarRoutes"
                            :key="route.route"
                            :to="route.route"
                            :class="{'sidebar-nav-item': true, 'selected': route.route == currentRoute.route}"
                            :title="currentLanguage === 'TA' ? route.titleTA : route.title"
                        >
                            <vue-feather :type="route.icon" size="20" />
                            <span class="nav-label">{{ currentLanguage === 'TA' ? route.titleTA : route.title }}</span>
                        </router-link>
                    </div>

                    <div class="sidebar-scrollable">
                        <!-- Subscriptions Section -->
                        <div v-if="subscriptions.length > 0" class="sidebar-section">
                            <div class="sidebar-section-title">{{ currentLanguage === 'TA' ? 'சந்தாக்கள்' : 'Subscriptions' }}</div>
                            <router-link
                                v-for="item in (showAllSubscriptions ? subscriptions : subscriptions.slice(0, 8))"
                                :key="item.id"
                                :to="`/@${item.subscribedTo.username}`"
                                class="sidebar-subscription-item"
                                :title="item.subscribedTo.displayName || item.subscribedTo.username"
                            >
                                <img :src="getSubscriptionAvatar(item.subscribedTo)" class="sidebar-avatar" @error="handleAvatarError"/>
                                <span class="sidebar-item-name">{{ item.subscribedTo.displayName || item.subscribedTo.username }}</span>
                            </router-link>
                            <a v-if="subscriptions.length > 8" @click.prevent="showAllSubscriptions = !showAllSubscriptions" class="sidebar-show-more" href="#">
                                <vue-feather :type="showAllSubscriptions ? 'chevron-up' : 'chevron-down'" size="16" />
                                <span class="nav-label">{{ showAllSubscriptions ? (currentLanguage === 'TA' ? 'குறைவாகக் காட்டு' : 'Show less') : (currentLanguage === 'TA' ? `மேலும் ${subscriptions.length - 8} காட்டு` : `Show ${subscriptions.length - 8} more`) }}</span>
                            </a>
                        </div>

                        <!-- Categories Section -->
                        <div v-if="categories && categories.length > 0" class="sidebar-section categories-section">
                            <div class="sidebar-section-title">{{ currentLanguage === 'TA' ? 'வகைகள்' : 'Categories' }}</div>
                            <router-link
                                v-for="item in parentCategories"
                                :key="item.id"
                                :to="`/category/${item.id}`"
                                class="sidebar-category-item"
                                :title="getCategoryName(item)"
                            >
                                <span class="category-name">{{ getCategoryName(item) }}</span>
                            </router-link>
                        </div>
                    </div>
                </div>


                <div :class="{'router-content': true, 'open': menuOn}">
                    <div class="site-announcement" :class="{ 'messages-announcement': $route.path.startsWith('/messages') }" v-if="showPreservationAnnouncement">
                        <div class="announcement-icon">
                            <vue-feather type="info" size="18" stroke-width="2.2"></vue-feather>
                        </div>
                        <div class="announcement-copy">
                            <strong>{{ currentLanguage === 'TA' ? 'புதிய தளத்திற்கு வரவேற்கிறோம்' : 'Welcome to the new experience' }}</strong>
                            <p>
                                {{ currentLanguage === 'TA'
                                    ? 'பாதுகாப்பு சம்பவம் ஒன்றின் காரணமாக பல காணொளிகள் அகற்றப்பட்டுள்ளன. எமது வரலாற்றைப் பாதுகாத்து அடுத்த தலைமுறைக்கு கொண்டு சேர்க்க உங்கள் பங்களிப்பு மிகவும் முக்கியமானது. உங்களிடம் ஈழம் தொடர்பான காணொளிகள் இருந்தால், @eelamtv பயனருக்கு ஒரு செய்தி அனுப்புங்கள். அவற்றைப் பகிர்வதற்கான வழிமுறைகளை நாங்கள் ஏற்படுத்தித் தருகிறோம். நன்றி.'
                                    : 'Most of our videos were removed due to a security incident. If you have videos you could share with us to preserve our history and share it, please send a message to the eelamtv user and we will assist with how to get them uploaded.'
                                }}
                            </p>
                        </div>
                        <router-link v-if="isLoggedIn" class="announcement-action" to="/messages/eelamtv">
                            {{ currentLanguage === 'TA' ? 'செய்தி அனுப்ப' : 'Message eelamtv' }}
                        </router-link>
                        <button v-else class="announcement-action announcement-login" type="button" @click="openLogin">
                            {{ currentLanguage === 'TA' ? 'செய்தி அனுப்ப உள்நுழையவும்' : 'Log in to message' }}
                        </button>
                        <button class="announcement-dismiss" type="button" @click="dismissPreservationAnnouncement" :title="currentLanguage === 'TA' ? 'மூடு' : 'Dismiss'">
                            <vue-feather type="x" size="18" stroke-width="2"></vue-feather>
                        </button>
                    </div>
                    <router-view :key="routeKey"></router-view>
                </div>


                <div class="footer">
                    <div>{{ currentLanguage === 'TA' ? 'பதிப்புரிமை © 2016-2030 ஈழம் தொலைக்காட்சி நிறுவனம். அனைத்து உரிமைகளும் உரிய உள்ளடக்க பதிப்புரிமையாளரைச் சேரும்.' : 'Copyright © 2016-2030 Eelam TV. All rights reserved by the respective content copyright holder.' }}</div>
                </div>
                <ToastContainer />
                <Login v-if="showLoginModal" @close="closeLogin" />
            </div>
</template>

<script>
import { API, Hub } from 'aws-amplify';
import { identify as analyticsIdentify, track as analyticsTrack, reset as analyticsReset } from './utils/analytics';
import "@aws-amplify/ui-vue/styles.css";
import ToastContainer from './components/ToastContainer.vue';
import Login from './components/Login.vue';
// import feather from 'feather-icons';

import { listVideoModelsTitlesEN, getUserModelLite, getUserModelLiteByUsername, getUserModelNotifications, getUserModelByLegacyId, subscriptionsBySubscriberId, backfillAuthOwnerMutation, messagesByReceiverAuthOwner, listMessageModelsForAuthOwner, onCreateMessageModelSimple, videosByOwnerIdAll, getVideoProcessingStatus } from './graphql/custom.js';
import { createUserModel } from './graphql/mutations';
import { createVideoModel } from './graphql/mutations.js';
import { listCategoryModelsWithChildren  } from './graphql/custom.js'
import { Storage } from "@aws-amplify/storage"
import { computed } from 'vue'
import { searchVideosWithFallback, searchUsersWithFallback } from './utils/algolia.js';
// // import { v4 as uuidv4 } from "uuid";
import ShortUniqueId from 'short-unique-id';
const uid = new ShortUniqueId();
let shortId = uid()
const PENDING_UPLOAD_KEY = 'eelamPendingVideoUpload';
const DISMISSED_PENDING_UPLOADS_KEY = 'eelamDismissedPendingVideoUploads';
const PRESERVATION_ANNOUNCEMENT_KEY = 'eelamPreservationAnnouncementDismissed';

function createEmptyVideo(id = uid()) {
    return {
        id,
        titleTA: '',
        titleEN: '',
        descriptionEN: '',
        descriptionTA: '',
        ownerId: null,
        videoModelPrimaryCategoryId: null,
        videoModelSecondaryCategoryId: null,
        publishState: 'pending',
        status: 'processing'
    };
}

export default {
    name: 'App',
    components: {
        ToastContainer,
        Login
    },
    provide() {
        return {
            currentLanguage: computed(() => this.currentLanguage),
            openLogin: () => this.openLogin(),
            currentUserRef: computed(() => this.currentUser),
            isAdminRef: computed(() => this.isAdmin)
        }
    },
    data() {
        return {
            currentRoute: { route: '' },
            timeout: null,
            sidebarOn: false,
            menuOn: false,
            notificationsOn: false,
            keyword: "",
            debouncedKeyword: "",
            searchResults: null,
            userResults: null,
            uploaded: false,
            hasPendingUploadReminder: false,
            uploading: false,
            uploadProgress: 0,
            created: false,
            creating: false,
            categories: [],
            currentUser: null,
            isAdmin: false,
            newVideo: createEmptyVideo(shortId),
            preparing: false,
            pollTimer: null,
            notifications: [],
            notificationsNextToken: null,
            loadingMoreNotifications: false,
            loadingNotifications: false,
            unreadCount: 0,
            unreadMessageCount: 0,
            lastSeenNotification: localStorage.getItem('lastSeenNotification') || '',
            notificationUnreadCutoff: '',
            notificationPanelUnreadCount: 0,
            messageSubscription: null,
            subscriptions: [],
            showAllSubscriptions: false,
            searching: false,
            showSearchResults: false,
            currentLanguage: 'EN', // Default to English
            darkMode: false, // Dark mode state
            showPreservationAnnouncement: localStorage.getItem(PRESERVATION_ANNOUNCEMENT_KEY) !== 'true',
            showLoginModal: false
        }
    },
    watch: {
        keyword(newValue) {
            if (this.timeout) clearTimeout(this.timeout);
            if (newValue && newValue.trim()) {
                this.showSearchResults = true;
            }
            this.timeout = setTimeout(() => {
                this.debouncedKeyword = newValue;
            }, 300);
        },
        debouncedKeyword(newValue) {
            if (newValue == "") {
                this.searchResults = null
                this.userResults = null
                this.showSearchResults = false
                return;
            }

            this.searchChanged(newValue.trim())
        },
        $route (to, from){
            console.log('route changed', to, from);

            let items = this.sidebarRoutes.filter(item => item.route == to.path)
            if (items.length > 0) {
                this.currentRoute = items[0]
            } else {
                this.currentRoute = {route: ''}
            }

            // Open login modal when navigating to ?login=1
            if (to.query.login) {
                this.openLogin();
                this.$router.replace({ query: { ...to.query, login: undefined } });
            }
        }
    },
    computed: {
        routeKey() {
            // Use base path for keying so sub-paths (like user tabs, message threads) don't remount the component
            const path = this.$route.path;
            // /@username/tab -> /@username
            if (path.startsWith('/@')) {
                return path.split('/').slice(0, 2).join('/');
            }
            // /messages/userId -> /messages
            if (path.startsWith('/messages')) {
                return '/messages';
            }
            return path;
        },
        avatarURL() {
            if (!this.currentUser) return '/avatar-placeholder.svg';
            const legacyAvatar = this.currentUser.model?.legacyAvatar;
            if (legacyAvatar) {
                if (legacyAvatar.startsWith('public/')) {
                    return `https://cdn1.eelam.tv/${legacyAvatar}`;
                }
                return `https://cdn.eelam.tv/${legacyAvatar}`;
            }
            const userId = this.currentUser.model?.id || this.currentUser['custom:legacyUserId'] || this.currentUser.sub;
            if (!userId) return '/avatar-placeholder.svg';
            return `https://cdn1.eelam.tv/public/images/user/${userId}/avatar.png`;
        },
        notificationIcon() {
            return this.notificationsOn ? 'bell' : 'bell-fill'
        },
        activeNotificationUnreadCount() {
            return this.notificationsOn ? this.notificationPanelUnreadCount : this.unreadCount;
        },
        profileUsername() {
            return this.currentUser?.model?.username || this.currentUser?.username || '';
        },
        accountDisplayName() {
            const user = this.currentUser?.model || {};
            const fullName = [user.firstName, user.lastName]
                .filter(Boolean)
                .join(' ')
                .trim();
            return fullName || user.displayName || this.profileUsername || '';
        },
        profileRoute() {
            return this.profileUsername ? `/@${this.profileUsername}` : '/settings/profile';
        },
        isGreyBackgroundEnabled() {
            return this.$route.path.includes('settings')
        },
        isLoggedIn() {
            return this.currentUser != null && this.currentUser.model != null;
        },
        parentCategories() {
            if (!this.categories) return [];
            return this.categories.filter(c => !c.categoryModelChildrenId);
        }
    },
    async created() {
        console.log('App created', this.$route)

        // Initialize language preference from localStorage
        const savedLanguage = localStorage.getItem('preferredLanguage');
        if (savedLanguage) {
            this.currentLanguage = savedLanguage;
        }

        // Initialize dark mode preference from localStorage
        const savedDarkMode = localStorage.getItem('darkMode');
        if (savedDarkMode === 'true') {
            this.darkMode = true;
            document.documentElement.classList.add('dark-mode');
        }

        // Listen for auth events (login/logout)
        Hub.listen('auth', async (data) => {
            const { payload } = data;
            console.log('Auth event:', payload.event);
            if (payload.event === 'signIn') {
                console.log('User signed in, initializing...');
                await this.initializeUser();
                analyticsTrack('login_success', {
                    flow: 'login',
                    step: 'login_form',
                    user_id: this.currentUser?.model?.id || this.currentUser?.sub,
                    username: this.currentUser?.username,
                    is_legacy_user: !!this.currentUser?.model?.legacyId,
                    path: this.$route?.fullPath || window.location.pathname
                });
            } else if (payload.event === 'signUp') {
                analyticsTrack('signup_success', {
                    flow: 'signup',
                    step: 'signup_form',
                    path: this.$route?.fullPath || window.location.pathname
                });
            } else if (payload.event === 'signOut') {
                console.log('User signed out');
                analyticsTrack('logout');
                analyticsReset();
                this.currentUser = null;
                this.subscriptions = [];
                this.notifications = [];
                this.unreadMessageCount = 0;
                this.teardownMessageSubscription();
            }
        });

        // Fetch categories for all users (including guests)
        this.fetchCategories();

        // Try to initialize if already authenticated
        try {
            await this.initializeUser();
        } catch (error) {
            console.log('User not authenticated yet, waiting for sign in...');
        }
    },
    beforeUnmount() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
        document.removeEventListener('keydown', this.onEscKey);
        window.removeEventListener('eelam:messages-read', this.checkUnreadMessages);
        window.removeEventListener('eelam:pending-upload-cleared', this.resetUploadState);
        this.teardownMessageSubscription();
        document.body.style.overflow = '';
    },
    mounted(){
        this.$watch( ()=> this.$route.path,(to, from)=> {
            console.log('route path has changed from ' +from+' to '+to )
            this.searchResults = null
            this.userResults = null
        })

        // ESC key to close login modal
        document.addEventListener('keydown', this.onEscKey);
        window.addEventListener('eelam:messages-read', this.checkUnreadMessages);
        window.addEventListener('eelam:pending-upload-cleared', this.resetUploadState);

        // Check for ?login=1 query param
        if (this.$route.query.login) {
            this.openLogin();
            this.$router.replace({ query: { ...this.$route.query, login: undefined } });
        }
    },
    methods: {
        dismissPreservationAnnouncement() {
            this.showPreservationAnnouncement = false;
            localStorage.setItem(PRESERVATION_ANNOUNCEMENT_KEY, 'true');
        },
        async initializeUser() {
            const user = await API.Auth.currentAuthenticatedUser();
            console.log('User authenticated:', user);

            const preferredUsername = user.attributes.preferred_username || user.attributes['custom:legacyUsername'] || user.username;
            this.currentUser = {
                ...user.attributes,
                username: preferredUsername,
                model: null
            };

            const accessGroups = user.signInUserSession?.accessToken?.payload?.["cognito:groups"] || [];
            const idGroups = user.signInUserSession?.idToken?.payload?.["cognito:groups"] || [];
            const groups = [...new Set([...accessGroups, ...idGroups])];
            this.isAdmin = groups.some(group => String(group).toLowerCase() === 'admin');

            await this.fetchUserDetails();
            analyticsIdentify(this.currentUser);
            await this.runAuthOwnerBackfill();
            await this.fetchSubscriptions();
            this.checkUnreadNotifications();
            this.checkUnreadMessages();
            this.setupMessageSubscription();
            await this.restorePendingUpload();
        },
        async runAuthOwnerBackfill() {
            const backfillKey = `authOwnerBackfilled:v2-message-auth:${this.currentUser?.sub || 'unknown'}`;
            if (localStorage.getItem(backfillKey)) return;
            if (this._backfillRunning) return;
            this._backfillRunning = true;

            console.log('backfill identity:', {
                sub: this.currentUser?.sub,
                legacyUserId: this.currentUser?.['custom:legacyUserId'],
                username: this.currentUser?.username,
                modelId: this.currentUser?.model?.id
            });

            // Retry loop: AppSync has a 30s timeout, so for users with lots of
            // content the Lambda may time out before finishing. Each run is
            // idempotent and picks up where it left off (skips already-backfilled
            // records). Keep calling until it reports 0 updates or succeeds.
            const MAX_RETRIES = 20;
            for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
                try {
                    const res = await API.graphql({
                        query: backfillAuthOwnerMutation,
                        authMode: 'AMAZON_COGNITO_USER_POOLS'
                    });
                    const result = res.data?.backfillAuthOwner;
                    if (result) {
                        console.log(`authOwner backfill attempt ${attempt}:`, result);
                        if (result.success) {
                            localStorage.setItem(backfillKey, 'true');
                            this._backfillRunning = false;
                            return;
                        }
                    }
                    break; // non-timeout failure, stop retrying
                } catch (err) {
                    const isTimeout = err.errors?.some(e =>
                        e.errorType?.includes('Timeout') || e.message?.includes('timed out')
                    );
                    if (isTimeout) {
                        console.log(`authOwner backfill attempt ${attempt}: timed out (Lambda still working), retrying...`);
                        continue;
                    }
                    // Check if Lambda actually succeeded despite partial error
                    if (err.data?.backfillAuthOwner?.success) {
                        console.log('authOwner backfill completed (with partial response)');
                        localStorage.setItem(backfillKey, 'true');
                        this._backfillRunning = false;
                        return;
                    }
                    console.error('authOwner backfill error:', err);
                    break;
                }
            }
            this._backfillRunning = false;
        },
        toggleMenu() {
            console.log('Toggling menu');
            this.menuOn = !this.menuOn
        },
        toggleNotifications() {
            console.log('Toggling notifications', this.notificationsOn);
            if (this.notificationsOn == true) {
                this.notificationsOn = false
                this.notificationUnreadCutoff = '';
                this.notificationPanelUnreadCount = 0;
            } else {
                this.notificationsOn = true
                analyticsTrack('notification_open');
                const previousLastSeen = localStorage.getItem('lastSeenNotification') || '';
                this.notificationUnreadCutoff = previousLastSeen;
                this.notificationPanelUnreadCount = this.unreadCount;
                const now = new Date().toISOString();
                this.fetchNotifications().then(() => {
                    if (!this.notificationPanelUnreadCount) {
                        this.notificationPanelUnreadCount = this.notifications.filter(n => this.isUnread(n)).length;
                    }
                    localStorage.setItem('lastSeenNotification', now);
                    this.lastSeenNotification = now;
                    this.unreadCount = 0;
                });
            }
        },
        hideMenu() {
            console.log('hiding menu')
            this.menuOn = false
        },
        hideNotifications() {
            console.log('hiding notifications')
            this.notificationsOn = false
            this.notificationUnreadCutoff = '';
            this.notificationPanelUnreadCount = 0;
        },
        toggleSidebar() {
            this.sidebarOn = !this.sidebarOn
        },
        async fetchNotifications() {
            console.log('fetching notifications')
            try {
                this.loadingNotifications = true;
                const userId = this.currentUser.model?.id || this.currentUser.sub;
                let notifsRes = await API.graphql({
                    query: getUserModelNotifications,
                    variables: {
                        userId: userId,
                        sortDirection: 'DESC',
                        limit: 20,
                    },
                    authMode: 'AMAZON_COGNITO_USER_POOLS'
                })
                this.notifications = notifsRes.data.notificationsByUser.items
                this.notificationsNextToken = notifsRes.data.notificationsByUser.nextToken
                console.log('notifications response', this.notifications)
            } catch (error) {
                console.error('Error fetching notifications:', error);
            } finally {
                this.loadingNotifications = false;
            }
        },
        async loadMoreNotifications() {
            if (!this.notificationsNextToken || this.loadingMoreNotifications) return;
            try {
                this.loadingMoreNotifications = true;
                const userId = this.currentUser.model?.id || this.currentUser.sub;
                let notifsRes = await API.graphql({
                    query: getUserModelNotifications,
                    variables: {
                        userId: userId,
                        sortDirection: 'DESC',
                        limit: 20,
                        nextToken: this.notificationsNextToken,
                    },
                    authMode: 'AMAZON_COGNITO_USER_POOLS'
                })
                this.notifications = [...this.notifications, ...notifsRes.data.notificationsByUser.items]
                this.notificationsNextToken = notifsRes.data.notificationsByUser.nextToken
            } catch (error) {
                console.error('Error loading more notifications:', error);
            } finally {
                this.loadingMoreNotifications = false;
            }
        },
        isUnread(notification) {
            const cutoff = this.notificationUnreadCutoff || this.lastSeenNotification;
            if (!cutoff) return true;
            return notification.createdAt > cutoff;
        },
        onNotificationScroll(e) {
            const el = e.target;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) {
                this.loadMoreNotifications();
            }
        },
        async checkUnreadNotifications() {
            try {
                const userId = this.currentUser.model?.id || this.currentUser.sub;
                const lastSeen = localStorage.getItem('lastSeenNotification');
                let unreadTotal = 0;
                let nextToken = null;
                let shouldContinue = true;
                do {
                    const res = await API.graphql({
                        query: getUserModelNotifications,
                        variables: {
                            userId: userId,
                            sortDirection: 'DESC',
                            limit: 50,
                            nextToken
                        },
                        authMode: 'AMAZON_COGNITO_USER_POOLS'
                    });
                    const page = res.data.notificationsByUser;
                    const items = page.items || [];
                    if (!lastSeen) {
                        unreadTotal += items.length;
                    } else {
                        unreadTotal += items.filter(n => n.createdAt > lastSeen).length;
                        shouldContinue = items.length > 0 && items.every(n => n.createdAt > lastSeen);
                    }
                    nextToken = page.nextToken;
                } while (nextToken && shouldContinue);

                if (!lastSeen) {
                    this.unreadCount = unreadTotal;
                } else {
                    this.unreadCount = unreadTotal;
                }
            } catch (error) {
                console.error('Error checking unread notifications:', error);
            }
        },
        async checkUnreadMessages() {
            try {
                const userId = this.currentUser?.model?.id || this.currentUser?.sub;
                const authOwner = this.currentUser?.sub || this.currentUser?.model?.authOwner;
                if (!userId || !authOwner) {
                    this.unreadMessageCount = 0;
                    return;
                }

                let unreadTotal = 0;
                let nextToken = null;
                do {
                    const page = await this.fetchReceivedMessagesForUnreadBadge(authOwner, nextToken);
                    unreadTotal += (page.items || []).filter(message => this.isUnreadMessageForBadge(message, userId)).length;
                    nextToken = page.nextToken;
                } while (nextToken);

                this.unreadMessageCount = unreadTotal;
            } catch (error) {
                console.error('Error checking unread messages:', error);
            }
        },
        async fetchReceivedMessagesForUnreadBadge(authOwner, nextToken = null) {
            try {
                const res = await API.graphql({
                    query: messagesByReceiverAuthOwner,
                    variables: {
                        receiverAuthOwner: authOwner,
                        limit: 100,
                        nextToken
                    },
                    authMode: 'AMAZON_COGNITO_USER_POOLS'
                });
                return res.data.messagesByReceiverAuthOwner || { items: [], nextToken: null };
            } catch (error) {
                console.warn('Falling back to message list lookup for unread badge:', error);
                const res = await API.graphql({
                    query: listMessageModelsForAuthOwner,
                    variables: {
                        filter: { receiverAuthOwner: { eq: authOwner } },
                        limit: 100,
                        nextToken
                    },
                    authMode: 'AMAZON_COGNITO_USER_POOLS'
                });
                return res.data.listMessageModels || { items: [], nextToken: null };
            }
        },
        isUnreadMessageForBadge(message, userId) {
            if (!message?.senderId || message.receiverId !== userId) return false;

            const lastReadAt = localStorage.getItem(`messagesLastRead:${userId}:${message.senderId}`);
            if (lastReadAt) {
                return new Date(message.createdAt) > new Date(lastReadAt);
            }

            return message.isRead === false;
        },
        setupMessageSubscription() {
            const userId = this.currentUser?.model?.id || this.currentUser?.sub;
            if (!userId) return;

            this.teardownMessageSubscription();
            this.messageSubscription = API.graphql({
                query: onCreateMessageModelSimple,
                variables: {
                    filter: {
                        receiverId: { eq: userId }
                    }
                },
                authMode: 'AMAZON_COGNITO_USER_POOLS'
            }).subscribe({
                next: (event) => {
                    const message = event.value.data.onCreateMessageModel;
                    if (message?.receiverId === userId && !message.isRead) {
                        this.unreadMessageCount += 1;
                    }
                },
                error: (error) => {
                    console.error('Error subscribing to unread messages:', error);
                }
            });
        },
        teardownMessageSubscription() {
            if (this.messageSubscription) {
                this.messageSubscription.unsubscribe();
                this.messageSubscription = null;
            }
        },
        async fetchUserDetails() {
            try {
                const cognitoSub = this.currentUser.sub;
                const legacyUserId = this.currentUser['custom:legacyUserId'];
                const username = this.currentUser.username;
                console.log('fetchUserDetails - cognitoSub:', cognitoSub, 'legacyUserId:', legacyUserId, 'username:', username);

                // Step 1: Migrated users must resolve by legacyId before Cognito sub.
                if (legacyUserId) {
                    try {
                        console.log('fetchUserDetails - trying to find by legacyId:', legacyUserId);
                        const legacyRes = await API.graphql({
                            query: getUserModelByLegacyId,
                            variables: { legacyId: legacyUserId }
                        });
                        if (legacyRes.data.userByLegacyId?.items?.length > 0) {
                            console.log('fetchUserDetails - found user by legacyId');
                            this.currentUser.model = legacyRes.data.userByLegacyId.items[0];
                            this.currentUser.username = this.currentUser.model.username || this.currentUser.username;
                            return;
                        }
                    } catch (e) {
                        console.warn('fetchUserDetails - Step 2 error (continuing):', e.errors?.[0]?.message || e.message);
                    }
                }

                // Step 2: Try to find user by Cognito sub (works for new users)
                try {
                    const userRes = await API.graphql({
                        query: getUserModelLite,
                        variables: { id: cognitoSub }
                    });
                    if (userRes.data.getUserModel) {
                        console.log('fetchUserDetails - found user by Cognito sub');
                        this.currentUser.model = userRes.data.getUserModel;
                        this.currentUser.username = this.currentUser.model.username || this.currentUser.username;
                        return;
                    }
                } catch (e) {
                    // May fail if a phantom record exists with null required fields
                    console.warn('fetchUserDetails - Step 2 error (continuing):', e.errors?.[0]?.message || e.message);
                }

                // Step 3: Try to find by username
                if (username) {
                    try {
                        console.log('fetchUserDetails - trying to find by username:', username);
                        const usernameRes = await API.graphql({
                            query: getUserModelLiteByUsername,
                            variables: { username }
                        });
                        if (usernameRes.data.userByUsername?.items?.length > 0) {
                            console.log('fetchUserDetails - found user by username');
                            this.currentUser.model = usernameRes.data.userByUsername.items[0];
                            this.currentUser.username = this.currentUser.model.username || this.currentUser.username;
                            return;
                        }
                    } catch (e) {
                        console.warn('fetchUserDetails - Step 3 error (continuing):', e.errors?.[0]?.message || e.message);
                    }
                }

                // Step 4: If still not found, create a new UserModel for this user
                console.log('fetchUserDetails - creating new UserModel for user');
                const now = new Date().toISOString();
                const createRes = await API.graphql({
                    query: createUserModel,
                    variables: {
                        input: {
                            id: cognitoSub,
                            username: username || this.currentUser.email?.split('@')[0] || `user_${cognitoSub.substring(0, 8)}`,
                            email: this.currentUser.email,
                            firstName: this.currentUser.given_name || null,
                            lastName: this.currentUser.family_name || null,
                            displayName: this.currentUser.given_name || username || 'New User',
                            createdAt: now,
                            emailVerified: this.currentUser.email_verified || false,
                        }
                    },
                    authMode: 'AMAZON_COGNITO_USER_POOLS'
                });
                console.log('fetchUserDetails - created new user:', createRes);
                this.currentUser.model = createRes.data.createUserModel;
                this.currentUser.username = this.currentUser.model.username || this.currentUser.username;
            } catch (error) {
                console.error('fetchUserDetails - error:', error);
            }
        },
        async fetchSubscriptions() {
            if (!this.currentUser?.model?.id) {
                this.subscriptions = [];
                return;
            }
            try {
                const res = await API.graphql({
                    query: subscriptionsBySubscriberId,
                    variables: {
                        subscriberId: this.currentUser.model.id,
                        limit: 50
                    }
                });
                this.subscriptions = (res.data.subscribersBySubscriberId?.items || []).filter(item => item.subscribedTo);
                console.log('Fetched subscriptions:', this.subscriptions);
            } catch (error) {
                console.error('Error fetching subscriptions:', error);
                this.subscriptions = [];
            }
        },
        async searchChanged(value) {
            if (value === "") {
                this.searchResults = null;
                this.userResults = null;
                this.searching = false;
                return;
            }

            this.searching = true;
            // Search channels (users) in parallel with videos; failures degrade to empty.
            this.searchUsersChanged(value);
            try {
                // Try Algolia search first
                const algoliaResults = await searchVideosWithFallback(value, {
                    hitsPerPage: 10,
                    attributesToHighlight: ['titleEN', 'titleTA', 'descriptionEN', 'descriptionTA']
                });
                console.log('Algolia search results:', value, algoliaResults);
                const algoliaVideos = algoliaResults?.results?.map(hit => ({
                    id: hit.id,
                    titleEN: hit.titleEN,
                    titleTA: hit.titleTA,
                    descriptionEN: hit.descriptionEN,
                    descriptionTA: hit.descriptionTA,
                    thumbnailUrl: hit.thumbnailUrl || hit.imageURL,
                    imageName: hit.imageName,
                    viewsCount: hit.viewsCount,
                    likesCount: hit.likesCount,
                    createdAt: hit.createdAt,
                    owner: hit.owner,
                    primaryCategory: hit.primaryCategory,
                    secondaryCategory: hit.secondaryCategory,
                    tags: hit.tags,
                    status: hit.status,
                    publishState: hit.publishState
                })).filter(video => this.isPublicSearchVideo(video)) || [];

                if (algoliaVideos.length > 0) {
                    analyticsTrack('search', { query: value, result_count: algoliaVideos.length, source: 'algolia' });
                    // Use Algolia results
                    this.searchResults = algoliaVideos;
                    this.showSearchResults = true;
                    console.log('Algolia search results:', this.searchResults);
                } else {
                    this.searchResults = await this.searchVideosWithGraphql(value);
                    analyticsTrack('search', {
                        query: value,
                        result_count: this.searchResults.length,
                        source: algoliaResults ? 'graphql_after_algolia_empty' : 'graphql'
                    });
                    this.showSearchResults = true;
                    console.log('GraphQL fallback search results:', this.searchResults);
                }
            } catch (error) {
                console.error('Error searching videos:', error);
                try {
                    this.searchResults = await this.searchVideosWithGraphql(value);
                    analyticsTrack('search', { query: value, result_count: this.searchResults.length, source: 'graphql_after_algolia_error' });
                    this.showSearchResults = true;
                } catch (fallbackError) {
                    console.error('GraphQL fallback search failed:', fallbackError);
                    this.searchResults = [];
                }
            } finally {
                // Owners/admins additionally get matching unpublished videos.
                await this.appendDraftSearchResults(value);
                this.searching = false;
            }
        },
        async searchUsersChanged(value) {
            try {
                const usersResponse = await searchUsersWithFallback(value, { hitsPerPage: 5 });
                const users = (usersResponse?.results || [])
                    .filter(hit => hit && hit.status !== 'banned')
                    .map(hit => ({
                        id: hit.id,
                        username: hit.username,
                        displayName: hit.displayName,
                        firstName: hit.firstName,
                        lastName: hit.lastName,
                        subscribersCount: hit.subscribersCount || 0,
                        status: hit.status,
                        isPro: hit.isPro || false
                    }));
                this.userResults = users;
                if (users.length > 0) {
                    this.showSearchResults = true;
                    analyticsTrack('search_users', { query: value, result_count: users.length, source: 'algolia' });
                }
            } catch (error) {
                console.error('Error searching users:', error);
                this.userResults = [];
            }
        },
        getSearchUserName(user) {
            if (!user) return 'Unknown';
            if (user.displayName) return user.displayName;
            const full = `${user.firstName || ''} ${user.lastName || ''}`.trim();
            return full || user.username || 'Unknown';
        },
        async searchVideosWithGraphql(value) {
            const trimmed = value.trim();
            const variants = [...new Set([
                trimmed,
                trimmed.toLowerCase(),
                trimmed.toUpperCase(),
                this.capitalizeFirstLetter(trimmed)
            ].filter(Boolean))];
            const resultsById = new Map();
            let nextToken = null;
            let pages = 0;

            do {
                const videosRes = await API.graphql({
                    query: listVideoModelsTitlesEN,
                    variables: {
                        limit: 100,
                        nextToken
                    }
                });
                const page = videosRes.data.listVideoModels;
                (page.items || [])
                    .filter(video => this.isPublicSearchVideo(video))
                    .filter(video => this.videoMatchesSearch(video, variants))
                    .forEach(video => resultsById.set(video.id, video));
                nextToken = page.nextToken;
                pages += 1;
            } while (nextToken && resultsById.size < 20 && pages < 10);

            return Array.from(resultsById.values()).slice(0, 20);
        },
        videoMatchesSearch(video, variants) {
            const haystack = [
                video.titleEN,
                video.titleTA,
                video.descriptionEN,
                video.descriptionTA,
                video.owner?.displayName,
                video.owner?.username
            ].join(' ').toLowerCase();
            return variants.some(term => haystack.includes(term.toLowerCase()));
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        // Searches unpublished (draft/pending/private/rejected/processing) videos via
        // authenticated GraphQL — NOT Algolia, whose index is public. Admins match across
        // all videos; a logged-in owner matches only their own.
        async searchDraftVideos(value) {
            const trimmed = value.trim();
            if (!trimmed) return [];

            const isAdmin = this.isAdmin;
            const ownerId = this.currentUser?.model?.id || this.currentUser?.sub || null;
            if (!isAdmin && !ownerId) return [];

            const variants = [...new Set([
                trimmed,
                trimmed.toLowerCase(),
                trimmed.toUpperCase(),
                this.capitalizeFirstLetter(trimmed)
            ].filter(Boolean))];
            const resultsById = new Map();

            try {
                if (isAdmin) {
                    // Admin: scan all videos, keep unpublished matches.
                    let nextToken = null;
                    let pages = 0;
                    do {
                        const res = await API.graphql({
                            query: listVideoModelsTitlesEN,
                            variables: { limit: 100, nextToken }
                        });
                        const page = res.data.listVideoModels;
                        (page.items || [])
                            .filter(video => !this.isPublicSearchVideo(video))
                            .filter(video => this.videoMatchesSearch(video, variants))
                            .forEach(video => resultsById.set(video.id, video));
                        nextToken = page.nextToken;
                        pages += 1;
                    } while (nextToken && resultsById.size < 20 && pages < 10);
                } else {
                    // Owner: only their own unpublished videos.
                    const res = await API.graphql({
                        query: videosByOwnerIdAll,
                        variables: { ownerId, limit: 100 }
                    });
                    (res.data.videosByOwner?.items || [])
                        .filter(video => !this.isPublicSearchVideo(video))
                        .filter(video => this.videoMatchesSearch(video, variants))
                        .forEach(video => resultsById.set(video.id, video));
                }
            } catch (error) {
                console.error('Draft search failed:', error);
            }

            return Array.from(resultsById.values()).slice(0, 20);
        },
        // Appends draft matches after the published results already in searchResults.
        async appendDraftSearchResults(value) {
            if (value === '') return;
            const drafts = await this.searchDraftVideos(value);
            if (!drafts.length) return;

            const byId = new Map();
            (this.searchResults || []).forEach(v => v && byId.set(v.id, v));
            drafts.forEach(v => { if (v && !byId.has(v.id)) byId.set(v.id, v); });
            this.searchResults = Array.from(byId.values());
            this.showSearchResults = true;
        },
        isDraftSearchResult(result) {
            return !!result && !this.isPublicSearchVideo(result);
        },
        draftBadgeLabel(result) {
            const publishState = result?.publishState;
            if (publishState && publishState !== 'published') {
                const labels = {
                    draft: this.currentLanguage === 'TA' ? 'வரைவு' : 'Draft',
                    pending: this.currentLanguage === 'TA' ? 'நிலுவை' : 'Pending',
                    private: this.currentLanguage === 'TA' ? 'தனிப்பட்டது' : 'Private',
                    rejected: this.currentLanguage === 'TA' ? 'நிராகரிக்கப்பட்டது' : 'Rejected'
                };
                return labels[publishState] || publishState;
            }
            // Published but still processing.
            return this.currentLanguage === 'TA' ? 'செயலாக்கம்' : 'Processing';
        },
        draftBadgeClass(result) {
            const publishState = result?.publishState;
            if (publishState && publishState !== 'published') return `badge-${publishState}`;
            return 'badge-processing';
        },
        isPublicSearchVideo(video) {
            return video &&
                (!video.status || video.status === 'ready') &&
                (!video.publishState || video.publishState === 'published');
        },
        isVerifiedCurrentUser() {
            const userModel = this.currentUser?.model;
            return userModel?.status === 'verified';
        },
        canPublishUploadsImmediately() {
            return this.isAdmin || this.isVerifiedCurrentUser();
        },
        getUploadPublishState() {
            return this.canPublishUploadsImmediately() ? 'published' : 'pending';
        },
        async onFileChange(e) {
            const file = e.target.files[0];
            analyticsTrack('video_upload_start', {
                file_size: file?.size,
                file_type: file?.type,
                publish_state: this.getUploadPublishState(),
                is_admin: this.isAdmin,
                is_verified_user: this.isVerifiedCurrentUser()
            });
            console.log('on change fired', file);

            this.newVideo.ownerId = this.currentUser.model?.id || this.currentUser.sub;
            this.newVideo.publishState = this.getUploadPublishState();
            console.log('saving...', this.newVideo)
            let saveResponse;
            try {
                saveResponse = await API.graphql({
                    query: createVideoModel,
                    variables: { input: this.newVideo },
                    authMode: 'AMAZON_COGNITO_USER_POOLS'
                });
            } catch (error) {
                analyticsTrack('video_upload_failed', {
                    stage: 'create_video_model',
                    error_code: this.getAnalyticsErrorCode(error),
                    publish_state: this.newVideo.publishState
                });
                throw error;
            }

            console.log('saved', saveResponse)
            this.persistPendingUpload('uploading');
            analyticsTrack('video_upload_model_created', {
                video_id: this.newVideo.id,
                publish_state: this.newVideo.publishState
            });

            this.uploading = true
            Storage.put(`videos/raw/${this.newVideo.id}.mp4`, file, {
                resumable: true,
                completeCallback: (event) => {
                    console.log(`Successfully uploaded ${event.key}`);
                    analyticsTrack('video_upload_file_complete', {
                        video_id: this.newVideo.id,
                        file_size: file?.size,
                        file_type: file?.type,
                        publish_state: this.newVideo.publishState
                    });
                    this.uploading = false
                    this.uploaded = true
                    this.uploadProgress = 0
                    this.imageURL = null
                    this.preparing = true
                    this.persistPendingUpload('preparing');
                    this.pollForThumbs()
                },
                progressCallback: (progress) => {
                    console.log(`Uploaded: ${progress.loaded}/${progress.total}`);
                    this.uploadProgress = (progress.loaded / progress.total) * 100
                },
                errorCallback: (err) => {
                    console.error('Unexpected error while uploading', err);
                    analyticsTrack('video_upload_failed', {
                        video_id: this.newVideo.id,
                        stage: 'storage_put',
                        error_code: this.getAnalyticsErrorCode(err),
                        publish_state: this.newVideo.publishState
                    });
                    this.$toast.error('Upload failed. Please try again.');
                    this.uploading = false
                    this.uploaded = false
                    this.clearPendingUpload()
                }
            });
        },
        getAnalyticsErrorCode(error) {
            const message = String(error?.errors?.[0]?.message || error?.message || error?.name || '').toLowerCase();
            if (!message) return 'unknown';
            if (message.includes('not authorized') || message.includes('unauthorized')) return 'unauthorized';
            if (message.includes('network') || message.includes('fetch')) return 'network_error';
            if (message.includes('timeout') || message.includes('timed out')) return 'timeout';
            if (message.includes('validation')) return 'validation_error';
            if (message.includes('storage') || message.includes('s3')) return 'storage_error';
            return 'error';
        },
        async getImageURL() {
            this.imageURL = `https://cdn1.eelam.tv/public/thumbs/${this.newVideo.id}_0.jpeg`
        },
        persistPendingUpload(phase) {
            if (!this.newVideo?.id) return;
            localStorage.setItem(PENDING_UPLOAD_KEY, JSON.stringify({
                phase,
                video: this.newVideo,
                ownerId: this.newVideo.ownerId,
                updatedAt: new Date().toISOString(),
                preparingStartedAt: phase === 'preparing'
                    ? new Date().toISOString()
                    : this.getPendingUpload()?.preparingStartedAt
            }));
            this.hasPendingUploadReminder = true;
        },
        getPendingUpload() {
            try {
                const raw = localStorage.getItem(PENDING_UPLOAD_KEY);
                return raw ? JSON.parse(raw) : null;
            } catch (error) {
                console.error('Error reading pending upload:', error);
                localStorage.removeItem(PENDING_UPLOAD_KEY);
                return null;
            }
        },
        getDismissedPendingUploadIds() {
            try {
                const raw = localStorage.getItem(DISMISSED_PENDING_UPLOADS_KEY);
                const ids = raw ? JSON.parse(raw) : [];
                return Array.isArray(ids) ? ids : [];
            } catch (error) {
                console.error('Error reading dismissed pending uploads:', error);
                localStorage.removeItem(DISMISSED_PENDING_UPLOADS_KEY);
                return [];
            }
        },
        isPendingUploadDismissed(videoId) {
            return Boolean(videoId && this.getDismissedPendingUploadIds().includes(videoId));
        },
        async restorePendingUpload() {
            let pendingUpload = this.getPendingUpload();
            const currentOwnerId = this.currentUser?.model?.id || this.currentUser?.sub;

            if (pendingUpload?.video?.id && this.isPendingUploadDismissed(pendingUpload.video.id)) {
                localStorage.removeItem(PENDING_UPLOAD_KEY);
                pendingUpload = null;
            }

            if (!pendingUpload?.video?.id) {
                pendingUpload = await this.findLatestPendingUpload(currentOwnerId);
                if (!pendingUpload?.video?.id) {
                    this.hasPendingUploadReminder = false;
                    return;
                }
                localStorage.setItem(PENDING_UPLOAD_KEY, JSON.stringify(pendingUpload));
            }

            if (pendingUpload.ownerId && currentOwnerId && pendingUpload.ownerId !== currentOwnerId) {
                this.hasPendingUploadReminder = false;
                return;
            }

            this.hasPendingUploadReminder = true;
            this.newVideo = {
                ...createEmptyVideo(pendingUpload.video.id),
                ...pendingUpload.video,
                ownerId: pendingUpload.ownerId || currentOwnerId
            };
            this.uploading = false;
            this.uploaded = true;
            this.uploadProgress = 0;

            if (pendingUpload.phase === 'ready') {
                this.preparing = false;
                return;
            }

            this.preparing = true;
            const startedAt = pendingUpload.preparingStartedAt
                ? new Date(pendingUpload.preparingStartedAt).getTime()
                : Date.now();
            this.pollForThumbs(startedAt);
        },
        async findLatestPendingUpload(ownerId) {
            if (!ownerId) return null;

            try {
                const res = await API.graphql({
                    query: videosByOwnerIdAll,
                    variables: {
                        ownerId,
                        limit: 20
                    },
                    authMode: 'AMAZON_COGNITO_USER_POOLS'
                });
                const latestPendingVideo = (res.data.videosByOwner?.items || []).find(video =>
                    video?.publishState === 'pending' &&
                    !this.isPendingUploadDismissed(video.id) &&
                    ['processing', 'thumbsReady', 'processingReady', 'failed', 'ready'].includes(video.status)
                );

                if (!latestPendingVideo) return null;

                const phase = ['thumbsReady', 'processingReady', 'failed', 'ready'].includes(latestPendingVideo.status)
                    ? 'ready'
                    : 'preparing';

                return {
                    phase,
                    video: {
                        ...createEmptyVideo(latestPendingVideo.id),
                        ...latestPendingVideo
                    },
                    ownerId,
                    updatedAt: new Date().toISOString(),
                    preparingStartedAt: latestPendingVideo.createdAt || new Date().toISOString()
                };
            } catch (error) {
                console.error('Error restoring latest pending upload:', error);
                return null;
            }
        },
        clearPendingUpload() {
            localStorage.removeItem(PENDING_UPLOAD_KEY);
            this.hasPendingUploadReminder = false;
        },
        resetUploadState() {
            this.clearPendingUpload();
            this.uploaded = false;
            this.uploading = false;
            this.uploadProgress = 0;
            this.preparing = false;
            if (this.pollTimer) {
                clearInterval(this.pollTimer);
                this.pollTimer = null;
            }
            this.newVideo = createEmptyVideo();
        },
        pollForThumbs(startedAt = Date.now()) {
            const startTime = startedAt;
            const POLL_INTERVAL = 5000; // 5 seconds
            const POLL_TIMEOUT = 5 * 60 * 1000; // 5 minutes
            if (this.pollTimer) {
                clearInterval(this.pollTimer);
                this.pollTimer = null;
            }

            const checkStatus = async () => {
                try {
                    const res = await API.graphql({
                        query: getVideoProcessingStatus,
                        variables: { id: this.newVideo.id }
                    });
                    const video = res.data.getVideoModel;
                    const status = video?.status;
                    if (!video) {
                        this.clearPendingUpload();
                        this.resetUploadState();
                        return;
                    }
                    if (status === 'thumbsReady' || status === 'ready' || status === 'processingReady') {
                        this.preparing = false;
                        clearInterval(this.pollTimer);
                        this.pollTimer = null;
                        this.persistPendingUpload('ready');
                        analyticsTrack('video_upload_processing_ready', {
                            video_id: this.newVideo.id,
                            status,
                            elapsed_ms: Date.now() - startTime
                        });
                        return;
                    }
                    if (status === 'failed') {
                        this.preparing = false;
                        clearInterval(this.pollTimer);
                        this.pollTimer = null;
                        this.persistPendingUpload('ready');
                        analyticsTrack('video_upload_processing_failed', {
                            video_id: this.newVideo.id,
                            error_code: video?.errorMessage ? 'processor_error' : 'unknown',
                            elapsed_ms: Date.now() - startTime
                        });
                        return;
                    }
                } catch (err) {
                    console.error('Error polling for thumbs:', err);
                }

                if (Date.now() - startTime >= POLL_TIMEOUT) {
                    console.warn('Thumbnail poll timed out, showing finish button anyway');
                    this.preparing = false;
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                    this.persistPendingUpload('ready');
                    analyticsTrack('video_upload_processing_timeout', {
                        video_id: this.newVideo.id,
                        elapsed_ms: Date.now() - startTime
                    });
                }
            };

            checkStatus();
            this.pollTimer = setInterval(checkStatus, POLL_INTERVAL);
        },
        async fetchCategories() {
            console.log('loading categories')
            let categoryRes = await API.graphql({ query: listCategoryModelsWithChildren })
            
            this.categories = categoryRes.data.listCategoryModels.items
            console.log('loaded categories', this.categories)
        },
        getNotificationIcon(type) {
            switch(type) {
                case 'video': return 'video';
                case 'comment': return 'message-square';
                case 'message': return 'message-circle';
                case 'subscription': return 'user-plus';
                default: return 'bell';
            }
        },
        getNotificationActor(notification) {
            if (this.isOwnVideoPublication(notification)) {
                return this.currentLanguage === 'TA' ? 'உங்கள் காணொளி' : 'Your video';
            }
            const profile = notification.profile;
            if (!profile) {
                return this.currentLanguage === 'TA' ? 'ஒருவர்' : 'Someone';
            }
            const name = profile.displayName || `${profile.firstName || ''} ${profile.lastName || ''}`.trim();
            return name || profile.username || (this.currentLanguage === 'TA' ? 'ஒருவர்' : 'Someone');
        },
        getNotificationAction(notification) {
            const ta = this.currentLanguage === 'TA';
            if (this.isOwnVideoPublication(notification)) {
                return ta ? 'வெளியிடப்பட்டது' : 'has been published';
            }
            switch(notification.type) {
                case 'video':
                    return ta ? 'புதிய காணொளியைச் சேர்த்தார்' : 'added a new video';
                case 'comment':
                    return ta ? 'கருத்திட்டார்' : 'commented on a video';
                case 'message':
                    return ta ? 'உங்களுக்குச் செய்தி அனுப்பினார்' : 'sent you a message';
                case 'subscription':
                    return ta ? 'உங்கள் சேனலில் சந்தா செலுத்தினார்' : 'subscribed to your channel';
                default:
                    return ta ? 'உங்கள் உள்ளடக்கத்துடன் தொடர்பு கொண்டார்' : 'interacted with your content';
            }
        },
        isOwnVideoPublication(notification) {
            return notification.type === 'video' && Boolean(notification.userId) &&
                notification.userId === notification.profileId;
        },
        getNotificationPreview(notification) {
            if (notification.type === 'comment') {
                return this.truncateNotificationText(notification.comment?.message || '');
            }
            if (notification.type === 'message') {
                return this.truncateNotificationText(notification.message?.content || '');
            }
            return '';
        },
        getNotificationTargetTitle(notification) {
            if (!notification.video) return '';
            return notification.video.titleEN || notification.video.titleTA || (this.currentLanguage === 'TA' ? 'காணொளி' : 'Video');
        },
        truncateNotificationText(text) {
            if (!text) return '';
            const normalized = String(text).replace(/\s+/g, ' ').trim();
            if (normalized.length <= 110) return normalized;
            return `${normalized.slice(0, 107).trim()}...`;
        },
        getNotificationLink(notification) {
            switch(notification.type) {
                case 'video':
                    return notification.videoId ? `/watch/${notification.videoId}` :
                        notification.video ? `/watch/${notification.video.id}` : '/';
                case 'comment':
                    return notification.video ? `/v/${notification.video.id}` : '/';
                case 'message':
                    return notification.profile?.username ? `/messages/${notification.profile.username}` : '/messages';
                case 'subscription':
                    return this.getProfileLink(notification.profile);
                default:
                    return '/';
            }
        },
        getProfileLink(profile) {
            if (!profile) return '/';
            return profile.username ? `/@${profile.username}` : '/';
        },
        formatTimeAgo(timestamp) {
            if (!timestamp) return '';

            const date = new Date(timestamp);
            if (isNaN(date.getTime())) return '';

            const now = new Date();
            const diffInSeconds = Math.floor((now - date) / 1000);
            const ta = this.currentLanguage === 'TA';

            if (diffInSeconds < 0) return '';
            if (diffInSeconds < 60) return ta ? 'இப்போது' : 'just now';
            if (diffInSeconds < 3600) {
                const mins = Math.floor(diffInSeconds / 60);
                return ta ? `${mins} ${mins === 1 ? 'நிமிடம்' : 'நிமிடங்கள்'} முன்` : `${mins} ${mins === 1 ? 'minute' : 'minutes'} ago`;
            }
            if (diffInSeconds < 86400) {
                const hours = Math.floor(diffInSeconds / 3600);
                return ta ? `${hours} மணி நேரம் முன்` : `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
            }
            if (diffInSeconds < 604800) {
                const days = Math.floor(diffInSeconds / 86400);
                return ta ? `${days} ${days === 1 ? 'நாள்' : 'நாட்கள்'} முன்` : `${days} ${days === 1 ? 'day' : 'days'} ago`;
            }
            if (diffInSeconds < 2592000) {
                const weeks = Math.floor(diffInSeconds / 604800);
                return ta ? `${weeks} ${weeks === 1 ? 'வாரம்' : 'வாரங்கள்'} முன்` : `${weeks} ${weeks === 1 ? 'week' : 'weeks'} ago`;
            }
            if (diffInSeconds < 31536000) {
                const months = Math.floor(diffInSeconds / 2592000);
                return ta ? `${months} ${months === 1 ? 'மாதம்' : 'மாதங்கள்'} முன்` : `${months} ${months === 1 ? 'month' : 'months'} ago`;
            }
            const years = Math.floor(diffInSeconds / 31536000);
            return ta ? `${years} ${years === 1 ? 'ஆண்டு' : 'ஆண்டுகள்'} முன்` : `${years} ${years === 1 ? 'year' : 'years'} ago`;
        },
        getSearchThumbnail(result) {
            if (result.thumbnailUrl && result.thumbnailUrl.trim()) {
                if (result.thumbnailUrl.startsWith('http')) return result.thumbnailUrl;
                return `https://cdn.eelam.tv/${result.thumbnailUrl}`;
            }
            const imageIndex = result.imageName || '0';
            return `https://cdn1.eelam.tv/public/thumbs/${result.id}_${imageIndex}.jpeg`;
        },
        handleThumbnailError(event) {
            if (event.target.src.endsWith('/video-placeholder.svg')) return;
            event.target.src = '/video-placeholder.svg';
        },
        getUserAvatar(user) {
            if (!user || !user.id) return '/avatar-placeholder.svg';
            if (user.legacyAvatar) {
                if (user.legacyAvatar.startsWith('public/')) {
                    return `https://cdn1.eelam.tv/${user.legacyAvatar}`;
                }
                return `https://cdn.eelam.tv/${user.legacyAvatar}`;
            }
            return `https://cdn1.eelam.tv/public/images/user/${user.id}/avatar.png`;
        },
        getSubscriptionAvatar(user) {
            if (!user || !user.id) return '/avatar-placeholder.svg';
            if (user.legacyAvatar) {
                if (user.legacyAvatar.startsWith('public/')) {
                    return `https://cdn1.eelam.tv/${user.legacyAvatar}`;
                }
                return `https://cdn.eelam.tv/${user.legacyAvatar}`;
            }
            return `https://cdn1.eelam.tv/public/images/user/${user.id}/avatar.png`;
        },
        handleAvatarError(event) {
            if (event.target.src.endsWith('/avatar-placeholder.svg')) return;
            event.target.src = '/avatar-placeholder.svg';
        },
        getCategoryName(category) {
            if (!category) return '';
            if (this.currentLanguage === 'TA') {
                return category.nameTA || category.nameEN || 'Unknown';
            }
            return category.nameEN || category.nameTA || 'Unknown';
        },
        formatNumber(num) {
            if (!num) return '0';
            if (num >= 1000000) {
                return (num / 1000000).toFixed(1) + 'M';
            } else if (num >= 1000) {
                return (num / 1000).toFixed(1) + 'K';
            }
            return num.toString();
        },
        clearSearch() {
            this.keyword = '';
            this.searchResults = null;
            this.userResults = null;
            this.showSearchResults = false;
        },
        hideSearchResults() {
            this.showSearchResults = false;
        },
        toggleLanguage() {
            this.currentLanguage = this.currentLanguage === 'EN' ? 'TA' : 'EN';
            // Store the preference in localStorage
            localStorage.setItem('preferredLanguage', this.currentLanguage);
            analyticsTrack('language_toggle', { language: this.currentLanguage });
        },
        async handleSignOut() {
            try {
                await API.Auth.signOut();
            } catch (error) {
                console.error('Error signing out:', error);
                this.$toast.error('Failed to sign out. Please try again.');
            }
        },
        openLogin() {
            this.showLoginModal = true;
            document.body.style.overflow = 'hidden';
        },
        closeLogin() {
            this.showLoginModal = false;
            document.body.style.overflow = '';
        },
        onEscKey(e) {
            if (e.key === 'Escape' && this.showLoginModal) {
                this.closeLogin();
            }
        },
        toggleDarkMode() {
            this.darkMode = !this.darkMode;
            // Apply or remove dark-mode class on root element
            if (this.darkMode) {
                document.documentElement.classList.add('dark-mode');
            } else {
                document.documentElement.classList.remove('dark-mode');
            }
            // Store the preference in localStorage
            localStorage.setItem('darkMode', this.darkMode.toString());
            analyticsTrack('theme_toggle', { theme: this.darkMode ? 'dark' : 'light' });
        },
    },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=SF+Pro:ital,wght@0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

/* @font-face {
  font-family: "Bamini";
  src: local("Bamini"),
   url(./fonts/Bamini-Regular.ttf) format("truetype");
} */

/* CSS Variables for theming */
:root {
    --bg-primary: #ffffff;
    --bg-secondary: #f9f9f9;
    --bg-tertiary: #f5f5f5;
    --bg-card: #ffffff;
    --bg-input: #f5f5f5;
    --bg-hover: #f0f0f0;
    --bg-sidebar: #ffffff;
    --bg-dropdown: #ffffff;

    --text-primary: #2c3e50;
    --text-secondary: #333333;
    --text-tertiary: #666666;
    --text-muted: #999999;
    --text-link: rgb(100, 100, 100);
    --text-link-hover: #137df3;

    --border-color: #e6e6e6;
    --border-light: #eaeaea;
    --shadow-color: rgba(0, 0, 0, 0.08);
    --shadow-dropdown: rgba(0, 0, 0, 0.23);

    --accent-primary: #ff1314;
    --accent-hover: #e00e0f;
    --accent-secondary: #4c4c4c;
    --accent-danger: #F44336;

    --header-bg: #ffffff;
    --hamburger-color: #333333;
}

/* Dark mode theme */
.dark-mode {
    --bg-primary: #1a1a1a;
    --bg-secondary: #121212;
    --bg-tertiary: #2d2d2d;
    --bg-card: #242424;
    --bg-input: #2d2d2d;
    --bg-hover: #3d3d3d;
    --bg-sidebar: #1a1a1a;
    --bg-dropdown: #242424;

    --text-primary: #e0e0e0;
    --text-secondary: #d0d0d0;
    --text-tertiary: #a0a0a0;
    --text-muted: #707070;
    --text-link: #b0b0b0;
    --text-link-hover: #4da6ff;

    --border-color: #3d3d3d;
    --border-light: #333333;
    --shadow-color: rgba(0, 0, 0, 0.3);
    --shadow-dropdown: rgba(0, 0, 0, 0.5);

    --accent-primary: #ff1314;
    --accent-hover: #e00e0f;
    --accent-secondary: #6c6c6c;
    --accent-danger: #e74c3c;

    --header-bg: #1a1a1a;
    --hamburger-color: #e0e0e0;
}

/* ========================================
   Amplify Authenticator Custom Styles
   (Split-panel dark theme)
   ======================================== */

[data-amplify-authenticator] {
    --amplify-fonts-default-static: 'Hind Madurai', 'Noto Sans Tamil', 'Anek Tamil', Arial, sans-serif;

    --amplify-colors-brand-primary-10: #3a3a3a;
    --amplify-colors-brand-primary-20: #444;
    --amplify-colors-brand-primary-40: #555;
    --amplify-colors-brand-primary-60: #666;
    --amplify-colors-brand-primary-80: #4a4a4a;
    --amplify-colors-brand-primary-90: #3a3a3a;
    --amplify-colors-brand-primary-100: #333;
    --amplify-colors-border-focus: #888;
    --amplify-colors-focus: #888;
    --amplify-components-authenticator-router-border-width: 0;
    --amplify-components-authenticator-router-box-shadow: none;
    --amplify-components-tabs-item-active-border-color: transparent;
    --amplify-components-tabs-item-active-color: #fff;
    --amplify-components-tabs-item-focus-color: #888;
    --amplify-components-fieldcontrol-focus-border-color: #888;
    --amplify-components-authenticator-container-width-max: 100%;
    --amplify-components-authenticator-max-width: 100%;

    background: transparent !important;
    min-height: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
}

[data-amplify-authenticator] [data-amplify-router] {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
}

[data-amplify-authenticator] [data-amplify-router]::before {
    display: none !important;
}

[data-amplify-authenticator] [data-amplify-form] {
    padding: 1rem 0 !important;
}

[data-amplify-authenticator] .amplify-tabs {
    display: none !important;
}

[data-amplify-authenticator] .amplify-input,
[data-amplify-authenticator] .amplify-field-group,
[data-amplify-authenticator] .amplify-button,
[data-amplify-authenticator] .amplify-flex {
    max-width: 100% !important;
    box-sizing: border-box !important;
}

/* Input fields — dark theme */
[data-amplify-authenticator] .amplify-input,
[data-amplify-authenticator] .amplify-field-group__control {
    border: 1px solid #444;
    border-radius: 8px;
    padding: 12px 14px;
    font-size: 15px;
    transition: all 0.2s ease;
    background-color: #2d2d2d;
    color: #ffffff;
}

[data-amplify-authenticator] .amplify-input:focus,
[data-amplify-authenticator] .amplify-field-group__control:focus {
    border-color: #888;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.05);
    background-color: #333;
    outline: none;
}

[data-amplify-authenticator] .amplify-input::placeholder {
    color: #777;
}

/* Labels — light gray on dark bg */
[data-amplify-authenticator] .amplify-label {
    font-weight: 500;
    font-size: 13px;
    color: #ccc;
    margin-bottom: 6px;
}

/* Primary button — muted dark gray */
[data-amplify-authenticator] .amplify-button--primary {
    background: #4a4a4a;
    border: none;
    border-radius: 8px;
    padding: 12px 20px;
    font-size: 15px;
    font-weight: 600;
    color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: 8px;
}

[data-amplify-authenticator] .amplify-button--primary:hover {
    background: #5a5a5a;
}

/* Link buttons */
[data-amplify-authenticator] .amplify-button--link {
    color: #aaa;
    font-weight: 500;
    font-size: 13px;
    transition: all 0.2s ease;
}

[data-amplify-authenticator] .amplify-button--link:hover {
    color: #fff;
}

/* Secondary buttons */
[data-amplify-authenticator] .amplify-button--default {
    border: 1px solid #444;
    border-radius: 8px;
    padding: 10px 16px;
    font-size: 13px;
    font-weight: 500;
    color: #aaa;
    background: #2d2d2d;
    transition: all 0.2s ease;
}

[data-amplify-authenticator] .amplify-button--default:hover {
    border-color: #666;
    color: #fff;
}

/* Password field show/hide button */
[data-amplify-authenticator] .amplify-field-group__outer-end .amplify-button {
    border-radius: 0 8px 8px 0;
    border: 1px solid #444;
    border-left: none;
    background: #2d2d2d;
    color: #888;
}

[data-amplify-authenticator] .amplify-field-group__outer-end .amplify-button:hover {
    background: #3a3a3a;
    color: #fff;
}

/* Field group for password */
[data-amplify-authenticator] .amplify-field-group {
    gap: 0;
}

[data-amplify-authenticator] .amplify-field-group .amplify-input {
    border-radius: 8px 0 0 8px;
}

/* Error messages */
[data-amplify-authenticator] .amplify-alert--error {
    background-color: #3a1c1c;
    border: 1px solid #5a2a2a;
    border-radius: 8px;
    color: #ff9999;
    padding: 10px 14px;
    font-size: 13px;
}

/* Divider */
[data-amplify-authenticator] .amplify-divider {
    margin: 16px 0;
    color: #666;
    font-size: 12px;
}

[data-amplify-authenticator] .amplify-divider::before,
[data-amplify-authenticator] .amplify-divider::after {
    background-color: #444;
}

/* Text */
[data-amplify-authenticator] .amplify-text {
    color: #999;
    font-size: 13px;
}

/* Heading */
[data-amplify-authenticator] .amplify-heading {
    font-size: 22px;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
}

/* Checkbox */
[data-amplify-authenticator] .amplify-checkbox__button {
    border: 1px solid #444;
    border-radius: 4px;
}

[data-amplify-authenticator] .amplify-checkbox__button--checked {
    background-color: #fff;
    border-color: #fff;
}

/* Loading spinner */
[data-amplify-authenticator] .amplify-loader {
    border-color: #888;
    border-top-color: transparent;
}

/* Responsive */
@media (max-width: 480px) {
    [data-amplify-authenticator] [data-amplify-form] {
        padding: 0.5rem 0;
    }
}

/* Dark mode — already dark, minimal overrides needed */
.dark-mode [data-amplify-authenticator] {
    background: transparent;
}

#app {
    font-family: 'Hind Madurai', 'Noto Sans Tamil', 'Anek Tamil', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-optical-sizing: auto;
    font-style: normal;
    color: var(--text-primary);
    background-color: var(--bg-secondary);
    min-height: 100vh;
}

body {
    margin: 0px;
    background-color: var(--bg-secondary);
}

.grey-background {
    background-color: var(--bg-secondary);
}
.logo {
    height: 36px;
}

.video-image {
    height: 300px;
}

.router-content {
    padding: 55px 0px 0px 82px;
    transition: padding-left 0.2s ease;
}

.content.open .router-content {
    padding-left: 230px;
}
.router-content h1{
    margin: 10px 0px;
}

.site-announcement {
    width: min(1120px, calc(100% - 40px));
    margin: 14px auto 16px;
    padding: 12px 12px 12px 14px;
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto auto;
    align-items: center;
    gap: 10px;
    background: rgba(31, 41, 55, 0.94);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(15, 23, 42, 0.14);
}

.announcement-icon {
    width: 28px;
    height: 28px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
}

.announcement-copy {
    min-width: 0;
}

.announcement-copy strong {
    display: block;
    font-size: 13px;
    line-height: 1.3;
    margin-bottom: 2px;
}

.announcement-copy p {
    margin: 0;
    color: rgba(255, 255, 255, 0.78);
    font-size: 12px;
    line-height: 1.4;
}

.announcement-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 34px;
    padding: 0 13px;
    border-radius: 999px;
    background: #ef4444;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    text-decoration: none;
    white-space: nowrap;
}

.announcement-login {
    border: 0;
    cursor: pointer;
    font-family: inherit;
}

.announcement-action:hover {
    background: #dc2626;
    color: #fff;
}

.announcement-dismiss {
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
    cursor: pointer;
}

.announcement-dismiss:hover {
    background: rgba(255, 255, 255, 0.18);
}

.messages-announcement {
    width: calc(100% - 40px);
    margin-top: 10px;
    margin-bottom: 22px;
}
.header-nav {
    background-color: var(--header-bg);
    z-index: 1000;
    box-shadow: 0 1px 2px var(--shadow-color);
    padding: 5px 0px;
}

.header-inner {
    display: grid !important;
    grid-template-columns: minmax(120px, 220px) minmax(280px, 500px) 76px minmax(260px, auto);
    align-items: center;
    gap: 16px;
}

.header-search {
    width: 100%;
    max-width: 500px;
    min-width: 0;
    justify-self: center;
}

.hamburger-container {
    cursor: pointer;
}

.bar1,
.bar2,
.bar3 {
    width: 20px;
    height: 2px;
    background-color: var(--hamburger-color);
    margin: 3px 0;
    transition: 0.4s;
}

.change .bar1 {
    transform: translate(0, 4px) rotate(-45deg);
}

.change .bar2 {
    opacity: 0;
}

.change .bar3 {
    transform: translate(0, -6px) rotate(45deg);
}
.header-profile-image {
    cursor: pointer;
}

.header-profile-image .profile-image {
    height: 35px;
    width: 35px;
    border-radius: 25px;
    object-fit: cover;
    display: block;
    background: #f1f3f5;
}

.profile-info .profile-image {
    height: 60px;
    width: 60px;
    border-radius: 35px;
    margin: 20px 25px 10px;
    object-fit: cover;
    display: block;
    background: #f1f3f5;
}
.profile-info a {
    text-decoration: none;
}
.search-box {
    position: relative;
    width: 100%;
}

.search-field {
    height: 40px;
    padding-left: 40px;
    padding-right: 32px; /* Make room for the loading indicator */
    color: var(--text-secondary);
    width: 100%;
    transition: all 0.2s;
    background-color: var(--bg-input);
    border: 0px;
    border-radius: 18px;
    font-size: 15px;
    border: 1px solid var(--border-light);
}

.search-box i {
    position: absolute;
    top: 10px;
    margin-left: 11px;
    color: var(--text-muted);
}

.search-loading {
    position: absolute;
    right: 40px;
    top: 2px;
    transform: translateY(-50%);
    color: var(--text-tertiary);
}

.search-clear-button {
    position: absolute;
    right: 21px;
    top: 5px;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: var(--text-muted);
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;
}

.search-clear-button:hover {
    color: var(--text-tertiary);
    background: var(--bg-hover);
}

.language-switch {
    margin: 0;
    width: 76px;
    display: flex;
    justify-content: center;
}

.language-toggle {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background-color: var(--bg-tertiary);
    border: 1px solid var(--border-light);
    border-radius: 20px;
    color: var(--text-tertiary);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 66px;
    height: 40px;
    justify-content: center;
}

.language-toggle:hover {
    background-color: var(--bg-hover);
    border-color: var(--border-color);
    color: var(--text-secondary);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px var(--shadow-color);
}

.language-toggle.active {
    background-color: var(--accent-primary);
    border-color: var(--accent-primary);
    color: white;
}

.language-toggle.active:hover {
    background-color: var(--accent-hover);
    border-color: var(--accent-hover);
}

.language-text {
    font-weight: 600;
    letter-spacing: 0.5px;
    min-width: 20px;
    text-align: center;
}

.language-toggle svg {
    transition: transform 0.2s ease;
}

.language-toggle:hover svg {
    transform: rotate(15deg);
}

.search-results {
    position: absolute;
    width: 100%;
    max-width: 500px;
    max-height: 480px;
    overflow-y: auto;
    background-color: var(--bg-dropdown);
    text-align: start;
    border-radius: 12px;
    box-shadow: 0 4px 20px var(--shadow-dropdown);
    border: 1px solid var(--border-light);
}

.search-results-header {
    padding: 12px 16px;
    font-size: 12px;
    font-weight: 500;
    color: var(--text-muted);
    border-bottom: 1px solid var(--border-light);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.search-item a {
    text-decoration: none;
    display: block;
    padding: 12px 16px;
    color: var(--text-secondary);
}

.search-item:hover {
    background-color: var(--bg-hover);
}

.search-item:last-child {
    border-radius: 0 0 12px 12px;
}

.search-item-content {
    display: flex;
    gap: 12px;
    align-items: flex-start;
}

.search-item-thumbnail {
    flex-shrink: 0;
    width: 140px;
    height: 80px;
    border-radius: 8px;
    overflow: hidden;
    background-color: var(--bg-tertiary);
}

.search-item-thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s ease;
}

.search-item:hover .search-item-thumbnail img {
    transform: scale(1.05);
}

.search-item-avatar {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    background-color: var(--bg-tertiary);
}

.search-item-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.search-item-details {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.search-item-title {
    font-weight: 600;
    font-size: 14px;
    line-height: 1.4;
    color: var(--text-secondary);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.verified-badge-inline {
    color: #ff1314;
    margin-left: 3px;
    vertical-align: middle;
}

.search-item:hover .search-item-title {
    color: var(--text-link-hover);
}

.search-item-badge {
    display: inline-block;
    vertical-align: middle;
    margin-left: 6px;
    padding: 1px 7px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.6;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.search-item-badge.badge-draft {
    background: #6b7280;
}

.search-item-badge.badge-pending {
    background: #7c3aed;
}

.search-item-badge.badge-private {
    background: #0891b2;
}

.search-item-badge.badge-rejected {
    background: #dc2626;
}

.search-item-badge.badge-processing {
    background: #f59e0b;
}

.search-item-meta {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: var(--text-tertiary);
    flex-wrap: wrap;
}

.search-item-channel {
    font-weight: 500;
    color: var(--text-tertiary);
}

.search-item-separator {
    color: var(--text-muted);
    font-size: 10px;
}

.search-item-views,
.search-item-date {
    color: var(--text-muted);
}

.search-no-results {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 20px;
    color: var(--text-tertiary);
    text-align: center;
}

.search-no-results svg {
    margin-bottom: 12px;
    color: var(--text-muted);
    opacity: 0.6;
}

.search-no-results p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}

.profile-image-medium img {
    height: 60px;
    width: 60px;
    border-radius: 50px;
    margin-top: 10px;
}

/* Sidebar - Minimized State (default) */
.side-bar {
    position: fixed;
    z-index: 1001;
    background: var(--bg-sidebar);
    width: 72px;
    height: 100vh;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    border-right: 1px solid var(--border-light);
    transition: width 0.2s ease;
}

.side-bar.expanded {
    width: 220px;
}

.sidebar-header {
    padding: 16px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid var(--border-light);
}

.side-bar.expanded .sidebar-header {
    justify-content: flex-start;
    padding: 16px 20px;
}

.sidebar-nav-section {
    padding: 12px 8px;
    border-bottom: 1px solid var(--border-light);
}

.sidebar-nav-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 12px;
    border-radius: 10px;
    text-decoration: none;
    color: var(--text-tertiary);
    font-size: 14px;
    font-weight: 500;
    transition: all 0.15s ease;
    margin-bottom: 2px;
}

.side-bar.expanded .sidebar-nav-item {
    justify-content: flex-start;
    padding: 10px 12px;
}

.sidebar-nav-item:hover {
    background-color: var(--bg-hover);
    color: var(--text-secondary);
}

.sidebar-nav-item.selected {
    background-color: var(--bg-tertiary);
    color: var(--text-link-hover);
}

.sidebar-nav-item svg {
    flex-shrink: 0;
}

.nav-label {
    display: none;
    white-space: nowrap;
}

.side-bar.expanded .nav-label {
    display: inline;
}

.sidebar-scrollable {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
}

.sidebar-scrollable::-webkit-scrollbar {
    width: 4px;
}

.sidebar-scrollable::-webkit-scrollbar-track {
    background: transparent;
}

.sidebar-scrollable::-webkit-scrollbar-thumb {
    background: var(--border-color);
    border-radius: 2px;
}

.sidebar-scrollable::-webkit-scrollbar-thumb:hover {
    background: var(--text-muted);
}

.sidebar-section {
    padding: 12px 8px 8px;
}

.sidebar-section-title {
    font-size: 10px;
    font-weight: 700;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
    padding: 0 8px;
    display: none;
}

.side-bar.expanded .sidebar-section-title {
    display: block;
    font-size: 11px;
    padding: 0 12px;
}

.sidebar-subscription-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 8px;
    border-radius: 10px;
    text-decoration: none;
    color: var(--text-secondary);
    font-size: 13px;
    font-weight: 500;
    transition: all 0.15s ease;
}

.side-bar.expanded .sidebar-subscription-item {
    justify-content: flex-start;
    padding: 8px 12px;
}

.sidebar-subscription-item:hover {
    background-color: var(--bg-hover);
}

.sidebar-avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    object-fit: cover;
    background-color: var(--bg-tertiary);
    flex-shrink: 0;
}

.side-bar.expanded .sidebar-avatar {
    width: 32px;
    height: 32px;
}

.sidebar-item-name {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: none;
}

.side-bar.expanded .sidebar-item-name {
    display: block;
}

.sidebar-show-more {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px;
    font-size: 13px;
    color: var(--text-muted);
    text-decoration: none;
    border-radius: 10px;
    transition: all 0.15s ease;
}

.side-bar.expanded .sidebar-show-more {
    justify-content: flex-start;
    padding: 8px 12px;
}

.sidebar-show-more:hover {
    background-color: var(--bg-hover);
    color: var(--text-link-hover);
}

/* Categories hidden in minimized state */
.categories-section {
    display: none;
}

.side-bar.expanded .categories-section {
    display: block;
}

.sidebar-category-item {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 10px;
    text-decoration: none;
    color: var(--text-secondary);
    font-size: 13px;
    font-weight: 500;
    transition: all 0.15s ease;
}

.sidebar-category-item:hover {
    background-color: var(--bg-hover);
    color: var(--text-link-hover);
}

.category-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.content .shadow {
    background-color: black;
    opacity: 0;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    visibility: hidden;
    transition: 0.4s;
    z-index: 1000;
    pointer-events: none;
}

.content.open .shadow {
    opacity: 0.5;
    visibility: visible;
    pointer-events: auto;
}

.footer {
    margin: 50px 0;
    font-size: 12px;
    text-align: center;
    color: var(--text-tertiary);
}
.menu-item {
    display: flex;
    width: 100%;
    padding: 10px 0;
    border-bottom: 1px solid var(--border-light);
}
.profile-dropdown {
    visibility: hidden;
    position: absolute;
    right: 10px;
    background-color: var(--bg-dropdown);
    border-radius: 5px;
    box-shadow: 0 1px 4px var(--shadow-dropdown);
    min-width: 192px;
    top: 60px;
}
.profile-dropdown.open {
    visibility: visible;
}

.profile-dropdown ul {
    padding: 0;
}
.profile-dropdown li {
    list-style-type: none;
}

.profile-dropdown li.divider {
    background: var(--border-light);
    margin: 6px 0;
    height: 1px;
}

.profile-dropdown li a {
    text-decoration: none;
    color: var(--text-link);
}

.header-menu-item {
    padding: 10px;
    font-size: 14px;
    color: var(--text-secondary);
}

.header-menu-item i {
    padding-right: 20px;
    padding-left: 10px;
}

a.header-menu-item:hover {
    color: #fff;
    background-color: var(--accent-secondary);
}

.icon-settings {
    padding-left: 6px;
}

.icon-logout{
    padding-left: 4px;
}

.action-icon-button {
    cursor: pointer;
    border: 1px solid var(--border-color);
    border-radius: 50%;
    width: 35px;
    height: 35px;
    display: block;
    line-height: 42px;
    padding-left: 1px;
    color: var(--text-secondary);
}
.action-icon-button:hover {
    background-color: var(--accent-secondary);
    color: white
}

.action-icon-button.logout {
    color: var(--accent-danger);
    padding-left: 4px;
}
.action-icon-button.logout:hover {
    background-color: var(--accent-danger);
    color: white
}
.profile-label {
    font-size: 15px;
    text-align: center;
    color: var(--text-secondary);
}

.notification-button {
    position: relative;
    padding: 8px 12px;
    margin-left: 8px;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 36px;
    height: 36px;
    background-color: transparent;
    border: 1px solid transparent;
    color: var(--text-secondary);
}

.notification-button:hover {
    background-color: var(--bg-hover);
    border-color: var(--border-color);
    transform: translateY(-1px);
}

.notification-button svg {
    width: 18px;
    height: 18px;
    display: block;
}

.right-header {
    min-width: 0;
    justify-content: flex-end;
    gap: 6px;
}

.upload-header {
    align-items: center;
    gap: 4px;
}

.upload-field {
    min-width: 142px;
    display: flex;
    justify-content: flex-end;
}

.upload-field .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-width: 116px;
    white-space: nowrap;
    line-height: 1;
}

.unread-badge {
    position: absolute;
    top: -2px;
    right: -2px;
    min-width: 14px;
    height: 14px;
    background-color: #ff3131;
    border-radius: 999px;
    border: 2px solid var(--bg-primary);
    color: white;
    font-size: 10px;
    font-weight: 700;
    line-height: 14px;
    text-align: center;
    padding: 0 3px;
    box-sizing: content-box;
}

.loading-more-notifications {
    display: flex;
    justify-content: center;
    padding: 10px;
    color: var(--text-tertiary);
}

.upload-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 0;
}

.upload-field {
    margin-right: 8px;
}
.login-button {
    display: flex;
    align-items: center;
    gap: 6px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    padding: 8px 18px;
    border-radius: 20px;
    color: white;
    background-color: var(--accent-primary);
    transition: all 0.2s ease;
}
.login-button:hover {
    background-color: var(--accent-hover);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px var(--shadow-color);
}
.notifications {
    visibility: hidden;
    position: absolute;
    right: 80px;
    background-color: var(--bg-dropdown);
    border-radius: 5px;
    box-shadow: 0 1px 4px var(--shadow-dropdown);
    min-width: 192px;
    max-width: 420px;
    top: 55px;
}
.notifications.open {
    visibility: visible;
}

.notifications h2 {
    font-size: 15px;
    border-bottom: 1px solid var(--border-light);
    margin: 0px;
    padding: 10px 10px;
    color: var(--text-secondary);
}

.notifications h2 .notific-count {
    display: inline-block;
    margin-left: 10px;
    background-color: #ff3131;
    border-radius: 20px;
    padding: 2px;
    font-size: 12px;
    text-align: center;
    line-height: 22px;
    height: 25px;
    width: 25px;
    color: white;
}
.notification-list {
    max-height: 70vh;
    overflow-y: auto;
}

.notification-item {
    display: grid;
    grid-template-columns: 46px minmax(0, 1fr);
    gap: 12px;
    min-width: 390px;
    color: var(--text-secondary);
    padding: 12px 14px;
    border-bottom: 1px solid var(--border-light);
    align-items: flex-start;
    transition: background-color 0.15s ease;
}
.notification-item:hover {
    background-color: var(--bg-hover);
}

.notification-item.unread {
    background-color: rgba(59, 130, 246, 0.08);
    box-shadow: inset 3px 0 0 #3b82f6;
}

.notification-item.unread:hover {
    background-color: rgba(59, 130, 246, 0.14);
}

.notification-item .profile-image {
    position: relative;
    flex-shrink: 0;
    width: 46px;
    height: 46px;
}

.notification-item .profile-image img{
    height: 46px;
    width: 46px;
    border-radius: 50%;
    object-fit: cover;
    background: var(--bg-hover);
}

.notification-item .icon-video {
    position: absolute;
    right: -2px;
    bottom: -2px;
    background-color: var(--accent-secondary);
    color: #ffffff;
    border-radius: 50%;
    text-align: center;
    box-shadow: 0 1px 3px var(--shadow-color);
    padding: 4px;
}

.notification-content {
    min-width: 0;
}

.notification-header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
}

.notification-title {
    min-width: 0;
    color: var(--text-primary);
    font-size: 14px;
    line-height: 1.35;
}

.notification-title b {
    font-weight: 700;
}

.notification-title span {
    margin-left: 4px;
    color: var(--text-secondary);
}

.unread-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #3b82f6;
    flex: 0 0 auto;
    margin-top: 5px;
}

.notification-preview {
    margin-top: 4px;
    color: var(--text-secondary);
    font-size: 13px;
    line-height: 1.35;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.notification-target {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    padding: 6px;
    background: var(--bg-hover);
    border-radius: 6px;
    min-width: 0;
}

.notification-target img {
    width: 64px;
    height: 36px;
    object-fit: cover;
    border-radius: 4px;
    flex-shrink: 0;
    background: var(--bg-card);
}

.notification-target-title {
    min-width: 0;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.notification-meta {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 7px;
    color: var(--text-tertiary);
    font-size: 12px;
}

.notification-meta svg {
    color: var(--text-tertiary);
    flex-shrink: 0;
}

.no-notifications {
    padding: 20px;
    text-align: center;
    color: var(--text-tertiary);
}

.no-notifications p {
    margin-top: 10px;
    font-size: 14px;
}

.loading-notifications {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    color: var(--text-tertiary);
    gap: 12px;
}

.loading-notifications span {
    font-size: 14px;
}

/* Upload Preparing Styles */
.preparing-container {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: var(--bg-tertiary);
    border-radius: 20px;
    border: 1px solid var(--border-light);
}

.preparing-text {
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
}

/* Upload Progress Bar Styles */
.progress-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 12px;
    background: var(--bg-tertiary);
    border-radius: 12px;
    border: 1px solid var(--border-light);
    min-width: 200px;
}

.progress-bar {
    width: 100%;
    height: 8px;
    background: var(--border-light);
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    box-shadow: inset 0 1px 3px var(--shadow-color);
}

.progress-fill {
    height: 100%;
    background: linear-gradient(90deg, var(--accent-primary), var(--accent-hover));
    border-radius: 10px;
    transition: width 0.3s ease;
    position: relative;
    overflow: hidden;
}

.progress-fill::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.3),
        transparent
    );
    animation: shimmer 2s infinite;
}

@keyframes shimmer {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}

.progress-text {
    font-size: 12px;
    font-weight: 500;
    color: var(--text-secondary);
    text-align: center;
}

/* Responsive search results */
@media (max-width: 768px) {
    .header-inner {
        grid-template-columns: auto minmax(0, 1fr) auto auto;
        gap: 8px;
    }

    .site-announcement {
        margin: 12px 12px 0;
        grid-template-columns: auto minmax(0, 1fr) auto;
        align-items: start;
    }

    .announcement-action {
        grid-column: 2 / 4;
        justify-self: start;
        margin-top: 2px;
    }

    .announcement-dismiss {
        grid-column: 3;
        grid-row: 1;
    }

    .upload-field {
        min-width: 0;
    }

    .search-results {
        width: calc(100vw - 40px);
        max-width: 400px;
        max-height: 400px;
    }

    .search-results-header {
        padding: 10px 12px;
        font-size: 11px;
    }

    .search-item a {
        padding: 10px 12px;
    }

    .search-item-content {
        gap: 10px;
    }

    .search-item-thumbnail {
        width: 100px;
        height: 56px;
    }

    .search-item-title {
        font-size: 13px;
        -webkit-line-clamp: 2;
    }

    .search-item-meta {
        font-size: 11px;
        gap: 4px;
    }

    .language-switch {
        margin: 0 8px;
        width: auto;
    }

    .language-toggle {
        padding: 6px 10px;
        font-size: 13px;
        width: 38px;
        height: 34px;
    }

    .language-toggle .language-text {
        display: none;
    }

    .language-toggle svg {
        margin: 0;
    }
}

/* Dark Mode Header Button */
.dark-mode-btn {
    background: none;
    border: none;
    color: var(--text-secondary);
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease, background-color 0.2s ease;
    margin-right: 8px;
}

.dark-mode-btn:hover {
    color: var(--text-primary);
    background-color: var(--bg-tertiary);
}

/* Dark Mode Toggle Styles */
.dark-mode-toggle {
    cursor: pointer;
    position: relative;
    justify-content: space-between;
    align-items: center;
}

.toggle-indicator {
    width: 36px;
    height: 20px;
    background-color: var(--bg-tertiary);
    border-radius: 10px;
    position: relative;
    transition: background-color 0.3s ease;
    margin-left: auto;
}

.toggle-indicator::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    background-color: var(--text-tertiary);
    border-radius: 50%;
    top: 2px;
    left: 2px;
    transition: transform 0.3s ease, background-color 0.3s ease;
}

.toggle-indicator.active {
    background-color: var(--accent-primary);
}

.toggle-indicator.active::after {
    transform: translateX(16px);
    background-color: white;
}

/* Ensure dark mode transitions smoothly */
* {
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}
</style>
